import React, { useEffect, useState } from "react";
import { biGet, biPatch, errText } from "./biApi";
import { Loading } from "./BiUi";

/** "⚙️ Configure School Active Classes": persists the active class list used by ALL analytics. */
export default function ActiveClassesModal({ user, onClose, onSaved }) {
  const [rows, setRows] = useState(null);
  const [picked, setPicked] = useState(new Set());
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    biGet(user, "/api/settings/active-classes").then((r) => {
      setRows(r.classes);
      setPicked(new Set(r.activeClassIds));
    }).catch((e) => setErr(errText(e)));
  }, [user]);

  const toggle = (id) => setPicked((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const save = async () => {
    setSaving(true); setErr("");
    try {
      await biPatch(user, "/api/settings/active-classes", { activeClassIds: [...picked] });
      onSaved && onSaved();
      onClose();
    } catch (e) { setErr(errText(e)); setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 p-4" onClick={onClose}>
      <div className="max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white p-6 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-black text-slate-900">⚙️ Configure School Active Classes</h3>
            <p className="mt-1 text-xs font-medium text-slate-500">Only ticked classes count in attendance, compliance, 7-day audit and 12-month records.</p>
          </div>
          <button onClick={onClose} className="text-xl font-bold text-slate-400 hover:text-slate-700">×</button>
        </div>
        {err && <div className="mt-3 rounded-lg bg-rose-50 px-3 py-2 text-xs font-bold text-rose-700">{err}</div>}
        {!rows ? <Loading /> : (
          <>
            <div className="mt-4 flex gap-3 text-xs font-bold">
              <button className="text-sky-600 hover:underline" onClick={() => setPicked(new Set(rows.map((r) => r._id)))}>Select all</button>
              <button className="text-slate-500 hover:underline" onClick={() => setPicked(new Set())}>Clear</button>
              <span className="ml-auto text-slate-500">{picked.size} / {rows.length} active</span>
            </div>
            <div className="mt-2 grid grid-cols-2 gap-2 sm:grid-cols-3">
              {rows.map((c) => (
                <label key={c._id} className={`flex cursor-pointer items-center gap-2 rounded-xl border px-3 py-2 text-sm font-bold ${picked.has(c._id) ? "border-emerald-300 bg-emerald-50 text-emerald-800" : "border-slate-200 text-slate-600"}`}>
                  <input type="checkbox" checked={picked.has(c._id)} onChange={() => toggle(c._id)} />
                  {c.name}{c.section ? ` ${c.section}` : ""}
                </label>
              ))}
            </div>
            <button disabled={saving || !picked.size} onClick={save}
              className="mt-5 w-full rounded-xl bg-slate-900 px-4 py-3 text-sm font-black text-white disabled:opacity-50">
              {saving ? "Saving..." : "Save Active Classes Configuration"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
